class ActionNode {
  constructor(model) {
    this.key = model.key || 0
    this.category = model.category
    this.text = model.text || ''
    this.answer = model.answer || ''
    this.value = model.value || ''
    this.parent = model.parent || null
    this.question = model.question || []
    this.content = model.content || 'something'
    this.goto = model.goto || null
    this.icon = {
      size: 20,
      name: '',
      line: ''
    }
    this.multiple = model.multiple || false
    this.same = model.same || null
  }

  changeValue(value) {
    this.value = value
    this.text = value
  }
}

export default ActionNode



// WEBPACK FOOTER //
// ./src/utils/models/node/ActionNode.js